import classNames from "classnames";
import React from "react";
import KuikaLoader from "../kuika-loader/kuika-loader";
import "./kuika-small-spinner.scss";

interface KuikaSmallSpinnerProps {
  className?: string;
  spinning?: boolean;
}

/** The 16px ring in brand blue: `KuikaLoader variant="ring"` under its original name, class and `aria-busy` contract. */
const KuikaSmallSpinner: React.FC<KuikaSmallSpinnerProps> = ({
  className,
  spinning = true
}: KuikaSmallSpinnerProps): JSX.Element => (
  <KuikaLoader
    variant="ring"
    size="md"
    busy={spinning}
    className={classNames("kuika-small-spinner", className)}
    data-testid="kuikaSmallSpinner"
  />
);

export default KuikaSmallSpinner;
